import { IGameData } from 'js/bubbleCore/types';
import { IEvent, createGridOffsetChangedEvent, createDeathLineCrossedEvent } from 'js/bubbleCore/events';
import { gridHexToSpacePosition } from 'js/bubbleCore/utils/gridHexToSpacePosition';

export function checkDeathLineCrossing(data: IGameData, events: IEvent[]): void {
  if (data.state.gameOver) return;

  const { grid } = data;

  const bubbles = Object.values(grid.values);

  if (bubbles.length === 0) return;

  const lowestBubble = bubbles.reduce((prevBubble, bubble) => {
    return prevBubble.row > bubble.row ? prevBubble : bubble;
  });

  const lowestBubbleSpace = gridHexToSpacePosition(lowestBubble.col, lowestBubble.row, grid);
  if (lowestBubbleSpace.y >= grid.deathLineY) {
    data.state.gameOver = true;
    events.push(createDeathLineCrossedEvent());
  }
}